import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import { FaSearch } from "react-icons/fa";
import { courseJson } from "../Model/contactModel";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function Home() {
  const [CourseFilterData, setCourseFilterData] = useState(courseJson);
  const [Country_Flag_Model, setCountry_Flag_Model] = useState([]);
  const [University_Logo_Model, setUniversity_Logo_Model] = useState([]);
  const [University_Logo_Navitas, setUniversity_Logo_Navitas] = useState([]);
  const [Univeristy_Logo_ECA, setUniveristy_Logo_ECA] = useState([]);

  const Get_Josn_Model_Data = async () => {
    try {
      const { data } = await axios.get("./Flag.json");
      setCountry_Flag_Model(data);
      const UniversityRes = await axios.get("./Universities.json");
      setUniversity_Logo_Model(UniversityRes?.data);
      const UniversityEcaRecs = await axios.get("./UniversityEca.json");
      setUniveristy_Logo_ECA(UniversityEcaRecs?.data);
      const UniveristyNavitasRecs = await axios.get("./UniversityNavitas.json");
      setUniversity_Logo_Navitas(UniveristyNavitasRecs?.data);
    } catch (ex) {
      console.log(ex);
    }
  };



  const Navigate = useNavigate();

  const handleChange = (e) => {
    setCourseFilterData({
      ...CourseFilterData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    Get_Josn_Model_Data();
  }, []);

  return (
    <>
      <>
        <div className="thetop"></div>
        <header className="header-section Header">
          <nav className="navbar navbar-expand-lg fixed-top" id="main_navbar">
            <div className="container navbar-container">
              <a className="navbar-brand white-logo" href="#">
                <img
                  src={"/assets/img/SE-logo.webp"}
                  alt="Search Education"
                  width="100%"
                />
              </a>
              <a className="navbar-brand color-logo" href="#">
                <img
                  src={"/assets/img/SE-logo.webp"}
                  alt="Search Education"
                  width="100%"
                />
              </a>
              {/* <h4>Biggest Education Fair</h4> */}
            </div>
          </nav>
        </header>
      </>
      {/* <div className="custom-header">
        <div className="speaking-evaluation">
          <div className="speaking-evaluationOverlay"></div>
          
          <div className="container">
            <div className="speaking-evaluation_title">
              <h1>Registration Form</h1>
            </div>
          </div>
        </div>
      </div> */}

      {/* Main Body */}

      <section className="section-padding bg-f3f3f3 Main_Container">
        <div className="section-body">
          <div className="Search_Box">
            <div className="footer-brand">
              <div className="email-subscribe">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    value={CourseFilterData?.CourseName}
                    name="CourseName"
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      if (
                        e.key === "Enter" &&
                        CourseFilterData?.CourseName !== "" &&
                        CourseFilterData?.CourseName !== undefined
                      ) {
                        Navigate(
                          `/course?course=${CourseFilterData?.CourseName}&university=&country=`
                        );
                      }
                    }}
                    placeholder="Search Courses"
                  />
                  <div className="input-group-append">
                    <button
                      onClick={() => {
                        if (
                          CourseFilterData?.CourseName !== "" &&
                          CourseFilterData?.CourseName !== undefined
                        ) {
                          Navigate(
                            `/course?course=${CourseFilterData?.CourseName}&university=&country=`
                          );
                        }
                      }}
                      className=" border-0 subscribe-btn"
                      type="button"
                    >
                      <FaSearch />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="Country_Section">
            <div>
              <div className="Flag_Container">
                {Country_Flag_Model?.map((ev) => (
                  <div
                    onClick={() =>
                      // setCourseFilterData({
                      //   ...setCourseFilterData,
                      //   Country: 1,
                      // })
                      Navigate(`/course?course=&university=&country=${ev?.Id}`)
                    }
                    className="Flag_Card"
                  >
                    <img src={ev?.Flag} alt="country" />
                    <span> {ev?.Name}</span>
                  </div>
                ))}
              </div>{" "}
            </div>
          </div>
          <div className="University_section">
            {University_Logo_Model?.map((ev) => (
              <div
                onClick={() =>
                  // setCourseFilterData({
                  //   ...setCourseFilterData,
                  //   University: 1,
                  // })
                  Navigate(`/course?course=&university=${ev?.Id}&country=`)
                }
                className="University_Card"
              >
                <img src={ev?.Logo} alt={ev?.Name} />
              </div>
            ))}
          </div>

          <div className="University_section">
            {University_Logo_Navitas?.map((ev) => (
              <div
                onClick={() =>
                  // setCourseFilterData({
                  //   ...setCourseFilterData,
                  //   University: 1,
                  // })
                  Navigate(`/course?course=&university=${ev?.Id}&country=`)
                }
                className="University_Card"
              >
                <img src={ev?.Logo} alt={ev?.Name} />
              </div>
            ))}
          </div>

          <div className="University_section">
            {Univeristy_Logo_ECA?.map((ev) => (
              <div
                onClick={() =>
                  // setCourseFilterData({
                  //   ...setCourseFilterData,
                  //   University: 1,
                  // })
                  Navigate(`/course?course=&university=${ev?.Id}&country=`)
                }
                className="University_Card"
              >
                <img src={ev?.Logo} alt={ev?.Name} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </>
  );
}

export default Home;
